/**
 * MODULE: toastContext — **`useToast`** + context token (**`ToastContainer`** provides)
 */

import { createContext, useContext } from 'react';
import type { Toast } from './toast.types';

interface ToastContextType {
  showToast: (toast: Omit<Toast, 'id'>) => void;
}

export const ToastContext = createContext<ToastContextType | null>(null);

export function useToast() {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastContainer');
  }
  return context;
}
